const KEY = "recently_viewed_products"
const MAX = 12

/**
 * Records a product id as most-recently-viewed in localStorage (deduped, capped).
 * No-op on the server.
 */
export function recordRecentlyViewed(id: string): void {
  if (typeof window === "undefined" || !id) return
  try {
    const raw = window.localStorage.getItem(KEY)
    const ids: string[] = raw ? JSON.parse(raw) : []
    const next = [id, ...ids.filter((x) => x !== id)].slice(0, MAX)
    window.localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    // ignore storage errors (private mode, quota, etc.)
  }
}

/**
 * Returns the recently-viewed product ids, most-recent first. Empty on the server.
 */
export function getRecentlyViewedIds(): string[] {
  if (typeof window === "undefined") return []
  try {
    const raw = window.localStorage.getItem(KEY)
    const ids = raw ? JSON.parse(raw) : []
    return Array.isArray(ids) ? ids : []
  } catch {
    return []
  }
}
